import PropTypes from 'prop-types';
import { BasicSvg } from './BasicSvg';

/**
 * Specific styled svg icon.
 * @param {string} props.width Width value.
 * @param {string} props.height Height value.
 * @param {string} props.fill Fill color - color name or value.
 * @param {string} props.stroke Stroke color - color name or value.
 * @param {string} props.strokeWidth Stroke width.
 * @param {string} props.viewBox Viewbox values.
 *
 * @returns {React.Component} Icon component.
 */
export const FallbackIcon = ({ width, height, fill, stroke, strokeWidth }) => {
  return (
    <BasicSvg
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      viewBox="0 0 969.000000 1280.000000"
      alt="fallback UI icon"
    >
      <>
        <g
          transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
          stroke="none"
        >
          <path d="M5120 12783 c-97 -30 -134 -55 -150 -101 -12 -35 -12 -46 -2 -63 10 -16 10 -24 2 -35 -9 -10 -9 -22 -2 -44 6 -16 8 -30 4 -30 -4 0 -32 28 -62 61 -77 88 -135 113 -244 107 -86 -6 -171 -34 -202 -69 -9 -10 -30 -19 -45 -19 -38 0 -77 -19 -84 -40 -10 -30 36 -132 96 -216 53 -73 69 -104 54 -104 -3 0 -27 11 -53 24 -159 81 -298 72 -457 -30 -27 -17 -61 -41 -74 -53 -17 -14 -31 -19 -45 -15 -12 4 -47 7 -78 7 -68 0 -156 -39 -230 -104 -58 -49 -64 -74 -15 -63 52 11 62 10 57 -6 -3 -8 -5 -57 -6 -109 0 -109 -7 -118 -59 -73 -86 76 -201 118 -298 109 -68 -6 -162 -49 -222 -100 -46 -40 -43 -63 12 -73 62 -11 470 -172 557 -221 91 -49 149 -101 175 -153 22 -44 57 -169 66 -233 6 -45 8 -48 33 -45 25 3 27 6 24 46 -3 37 0 44 17 49 12 3 21 9 21 14 0 15 -79 171 -141 279 -79 136 -107 228 -121 402 -6 76 -9 141 -5 144 4 4 29 9 55 12 91 8 265 -61 358 -142 58 -51 119 -161 159 -286 48 -149 108 -310 116 -310 22 0 39 15 39 34 0 36 12 66 25 66 45 0 25 140 -39 275 -51 107 -112 182 -255 312 -72 65 -131 121 -131 124 0 11 41 19 125 26 142 10 333 -52 403 -132 51 -57 75 -116 161 -392 29 -92 35 -103 56 -103 13 0 29 10 39 25 13 20 23 24 53 22 l38 -2 9 52 c11 63 -9 131 -85 291 -38 81 -64 121 -123 185 -42 45 -76 89 -76 98 0 9 9 26 20 39 11 13 20 27 20 32 0 5 -24 61 -54 123 -59 125 -59 125 9 144 64 17 123 14 134 -8 6 -10 32 -24 58 -32 91 -25 198 -154 249 -300 23 -65 27 -96 33 -262 6 -153 10 -190 23 -203 9 -9 24 -14 33 -11 13 6 15 16 9 56 -6 46 -5 49 13 45 28 -8 41 14 54 93 11 69 11 73 -25 188 -21 65 -55 155 -77 200 -47 100 -48 109 -10 100 19 -4 30 -2 33 7 3 7 -6 57 -20 112 -30 119 -26 143 32 163 161 55 396 -231 461 -560 16 -83 16 -92 0 -140 -16 -48 -16 -52 1 -64 15 -11 21 -10 36 4 10 9 18 21 18 28 0 16 33 45 52 45 10 0 24 22 37 58 l22 59 -29 84 c-39 113 -80 192 -170 329 -91 140 -162 210 -257 256 -79 37 -88 38 -155 17z" />
          <path d="M6630 12673 c0 -9 31 -161 70 -337 152 -704 222 -1047 236 -1166 9 -69 22 -140 30 -159 8 -18 14 -49 14 -67 0 -20 58 -184 140 -391 76 -197 529 -1361 1005 -2588 476 -1227 873 -2245 883 -2263 9 -18 26 -35 37 -37 58 -12 106 -10 164 6 35 10 104 25 153 34 143 25 198 61 198 131 0 31 7 51 26 74 47 55 44 95 -24 270 -33 85 -230 592 -437 1125 -514 1322 -783 2014 -1185 3050 -286 738 -347 886 -375 915 -33 35 -337 498 -560 854 -66 105 -135 210 -154 235 -20 25 -56 80 -81 121 -76 123 -132 210 -136 210 -2 0 -4 -8 -4 -17z m710 -1568 c0 -8 -9 -15 -20 -15 -20 0 -26 11 -13 23 12 13 33 7 33 -8z m-210 -94 c0 -12 -20 -25 -27 -18 -7 7 6 27 18 27 5 0 9 -4 9 -9z m965 -2606 l956 -2459 -23 -43 c-13 -24 -27 -42 -31 -40 -5 1 -47 101 -94 222 -92 238 -909 2339 -1442 3713 l-332 853 -6 117 c-4 87 -3 114 6 106 6 -5 441 -1117 966 -2469z" />
          <path d="M2728 11650 c-62 -11 -101 -40 -127 -93 -26 -53 -26 -60 -1 -158 12 -44 18 -84 15 -89 -3 -5 -40 9 -83 31 -97 49 -197 71 -263 59 -92 -18 -173 -73 -222 -152 -15 -24 -22 -26 -84 -26 -101 -1 -283 -62 -283 -96 0 -20 18 -24 65 -15 87 17 128 11 254 -41 162 -67 184 -79 264 -142 74 -60 143 -133 197 -213 19 -28 57 -83 84 -123 27 -40 52 -72 56 -72 3 0 14 6 24 13 18 13 18 16 -6 58 -14 24 -31 66 -37 93 -26 106 -73 177 -193 289 -99 93 -170 151 -235 194 -17 12 -17 13 2 29 17 13 39 15 140 11 146 -6 213 -27 340 -111 138 -91 200 -162 272 -307 33 -68 66 -136 72 -151 12 -30 32 -36 50 -14 8 10 9 21 0 42 -20 52 -28 177 -13 195 21 23 1 71 -62 149 -70 88 -126 141 -204 193 -69 46 -77 61 -79 138 -1 41 4 51 42 92 53 57 82 65 158 42 116 -35 192 -131 300 -375 23 -52 54 -108 69 -125 15 -16 37 -49 49 -72 14 -29 28 -43 41 -43 11 0 20 -4 20 -10 0 -5 12 -10 26 -10 25 0 26 2 20 41 -4 23 -23 83 -42 133 -20 50 -48 124 -64 165 -32 80 -55 120 -137 227 -53 70 -179 184 -247 225 -40 23 -112 31 -178 19z" />
          <path
            d="M5155 10620 c-599 -291 -1216 -589 -1370 -661 -254 -120 -590 -288
-574 -289 8 0 334 153 1014 475 264 125 559 263 655 307 96 44 195 90 219 104
23 13 287 139 585 280 297 141 551 262 564 270 24 15 30 45 10 43 -7 0 -503
-239 -1103 -529z"
          />
          <path
            d="M1302 11005 c-121 -62 -172 -106 -151 -132 25 -29 71 -43 294 -88
208 -42 237 -50 319 -93 66 -33 110 -65 159 -114 37 -37 67 -73 67 -79 0 -7
12 -37 27 -68 14 -31 43 -92 64 -136 34 -73 78 -135 95 -135 3 0 3 17 0 38
-14 82 -18 170 -8 189 15 26 -22 104 -74 159 -21 23 -74 84 -117 137 -43 52
-128 144 -190 204 -134 129 -195 164 -302 171 -69 4 -72 3 -183 -53z"
          />
          <path
            d="M930 10801 c-25 -10 -90 -35 -144 -56 -55 -21 -110 -49 -122 -61 -20
-22 -25 -23 -73 -14 -84 16 -211 -18 -259 -70 -19 -21 -31 -23 -110 -24 -101
-1 -122 -11 -122 -60 0 -17 -7 -63 -15 -101 -17 -83 -19 -214 -4 -285 7 -31
28 -77 53 -114 24 -34 53 -93 65 -131 28 -86 42 -113 79 -153 34 -37 68 -42
77 -11 5 15 -7 39 -48 93 -30 40 -64 91 -76 113 -27 53 -103 510 -90 535 14
26 83 58 124 58 26 0 45 -9 73 -35 55 -49 145 -227 176 -347 29 -113 65 -189
111 -238 30 -32 33 -42 39 -117 7 -87 19 -133 35 -133 31 0 36 207 7 272 -9
21 -16 44 -16 53 0 18 -59 206 -70 220 -4 6 -31 69 -61 140 -42 103 -63 139
-96 172 -24 22 -43 44 -43 47 0 3 19 6 43 6 99 0 301 -79 408 -159 93 -70 167
-229 203 -437 17 -96 30 -121 53 -102 9 7 13 28 11 62 -1 28 4 62 11 75 12 21
7 34 -50 145 -34 66 -73 138 -86 160 -40 62 -183 235 -214 257 -27 19 -40 49
-21 49 4 0 50 -13 102 -29 52 -17 138 -42 190 -56 197 -54 325 -119 409 -206
37 -39 121 -187 121 -215 0 -18 21 -32 41 -27 10 3 19 14 19 24 0 27 -33 107
-68 164 -17 28 -52 86 -77 129 -75 127 -308 364 -400 407 -50 23 -126 24 -185
0z"
          />
          <path
            d="M5580 9964 c-1847 -896 -2119 -1028 -2116 -1031 4 -4 383 174 1761
827 572 271 1084 512 1138 536 121 52 147 69 147 94 0 11 -3 20 -7 19 -5 0
-420 -200 -923 -445z"
          />
          <path
            d="M6850 9773 c-8 -3 -134 -64 -280 -135 -711 -348 -1151 -563 -1765
-860 -617 -299 -913 -446 -875 -434 17 5 -29 -17 1530 721 619 292 1193 563
1275 602 118 55 151 75 153 92 3 21 -8 25 -38 14z"
          />
          <path
            d="M127 9666 c-54 -18 -100 -36 -103 -38 -2 -3 252 -779 566 -1724 315
-946 746 -2245 960 -2889 491 -1477 1250 -3781 1456 -4415 86 -267 160 -489
164 -493 4 -5 51 5 104 22 53 17 101 31 106 31 5 0 16 -16 25 -35 l14 -36 43
22 c24 12 140 74 258 137 118 63 307 162 420 219 113 58 252 133 310 168 58
35 1068 575 2245 1200 1177 625 2210 1174 2295 1220 85 45 197 105 247 131 87
46 116 74 75 74 -18 0 -523 -264 -757 -395 -136 -76 -3095 -1650 -3200 -1702
-326 -160 -1342 -695 -1426 -751 -64 -42 -465 -252 -481 -252 -8 0 -34 62 -72
173 -90 265 -460 1391 -521 1582 -29 94 -63 195 -74 225 -11 30 -57 170 -102
310 -44 140 -92 287 -106 325 -13 39 -62 187 -109 329 -80 249 -100 322 -70
266 17 -31 192 -504 202 -545 4 -16 36 -106 71 -200 36 -93 72 -190 80 -215 9
-25 22 -61 31 -80 8 -19 36 -98 62 -175 63 -183 309 -857 370 -1010 26 -66 69
-181 94 -255 26 -74 65 -180 86 -235 21 -55 41 -112 44 -127 6 -28 29 -37 41
-18 3 5 -10 52 -30 102 -21 51 -53 140 -72 198 -39 117 -342 945 -397 1085
-19 50 -56 149 -81 220 -26 72 -62 171 -80 220 -18 50 -41 119 -51 155 -10 36
-26 85 -37 110 -36 85 -304 805 -432 1160 -70 195 -156 434 -192 530 -217 587
-279 761 -352 985 -44 138 -132 408 -195 602 -64 193 -124 386 -135 430 -22
83 -129 403 -261 778 -92 263 -324 964 -335 1013 -3 17 -4 32 -1 32 10 0 46
-93 230 -589 294 -795 388 -1051 411 -1126 26 -83 163 -442 242 -634 31 -75
77 -197 103 -271 26 -74 66 -180 89 -234 23 -55 62 -160 88 -235 25 -75 70
-199 100 -276 30 -77 65 -169 78 -205 45 -128 547 -1425 555 -1435 8 -10 215
-533 361 -910 38 -99 79 -202 90 -230 44 -104 212 -524 251 -625 22 -58 71
-168 108 -245 37 -77 80 -169 96 -205 16 -36 40 -82 53 -103 29 -46 24 -53
-61 -87 -55 -21 -71 -41 -47 -55 6 -4 36 6 67 23 75 40 1206 576 1302 617 92
40 819 386 1175 560 143 69 297 142 343 161 82 34 495 235 917 446 121 61 258
127 305 148 201 88 1292 623 1390 681 94 55 117 76 104 89 -8 8 -79 -25 -259
-119 -137 -72 -310 -158 -384 -192 -75 -34 -225 -107 -334 -161 -249 -124
-1299 -632 -1892 -915 -247 -118 -517 -249 -600 -290 -224 -112 -1954 -933
-1966 -933 -9 0 -49 81 -49 100 0 4 -15 34 -33 67 -17 32 -43 85 -56 118 -13
33 -46 108 -73 166 -26 58 -48 113 -48 122 0 10 11 19 28 23 15 4 47 18 72 32
25 14 95 37 155 53 136 34 345 93 445 124 108 35 243 70 420 110 85 19 221 53
301 75 205 56 234 53 131 -11 -31 -20 -228 -117 -437 -214 -615 -288 -925
-441 -925 -459 0 -9 2 -16 4 -16 3 0 92 42 198 94 337 164 810 387 888 418 41
17 158 70 260 118 376 178 577 267 640 284 36 10 101 29 145 42 131 41 252 38
318 -8 14 -11 19 -10 27 2 17 27 11 48 -17 59 -36 13 -86 58 -78 70 3 5 36 17
73 25 81 19 179 50 188 59 13 12 -16 35 -38 29 -15 -3 -19 -1 -16 9 2 8 177
94 389 191 211 97 467 216 569 264 195 92 222 98 284 69 54 -26 194 -18 233
13 40 32 95 56 252 108 165 55 349 144 470 228 99 69 226 198 218 220 -7 18
17 28 47 20 34 -8 358 104 519 180 88 42 115 72 97 107 -7 12 -22 52 -35 90
-13 37 -57 130 -98 206 -41 76 -107 201 -147 278 -40 77 -83 156 -95 175 -12
19 -34 59 -49 88 -21 41 -32 52 -50 52 -13 0 -29 -6 -35 -14 -21 -25 -100
-255 -112 -323 -32 -194 -41 -231 -68 -289 -16 -34 -60 -102 -96 -150 -37 -49
-80 -111 -96 -139 -16 -28 -39 -61 -51 -72 -13 -12 -635 -287 -1383 -611 -748
-324 -1452 -630 -1565 -680 -113 -49 -503 -221 -867 -381 -649 -285 -666 -292
-887 -354 -171 -49 -229 -61 -240 -53 -13 10 -187 462 -686 1776 -105 278
-216 573 -245 655 -49 136 -142 378 -399 1045 -48 124 -464 1219 -924 2434
-460 1214 -841 2207 -847 2205 -10 -4 -10 -23 1 -76 5 -26 3 -34 -12 -40 -11
-3 -22 -11 -25 -16 -14 -20 -29 7 -64 113 -20 61 -37 110 -38 110 -1 -1 -46
-16 -100 -34z m527 -892 c144 -373 226 -597 226 -612 -1 -20 -81 170 -152 358
-100 268 -238 649 -238 657 0 19 23 -38 164 -403z m-6 -279 c17 -55 29 -101
28 -103 -2 -2 -19 41 -36 95 -18 54 -35 105 -38 113 -3 10 -2 12 5 5 6 -5 24
-55 41 -110z m435 -845 c355 -935 451 -1189 488 -1295 21 -60 95 -258 164
-440 70 -181 142 -370 160 -420 17 -49 120 -322 227 -605 108 -283 198 -528
202 -545 17 -84 -74 136 -251 604 -107 284 -201 530 -209 546 -8 17 -18 44
-23 60 -13 46 -267 716 -317 838 -87 210 -631 1683 -637 1722 l-6 40 19 -35
c10 -19 92 -231 183 -470z m1514 -4010 c30 -80 68 -174 83 -210 38 -87 320
-836 320 -850 0 -34 -27 23 -108 227 -50 126 -125 320 -167 433 -42 113 -103
277 -137 365 -61 162 -88 242 -87 260 1 15 35 -65 96 -225z m6403 -17 c-1 -28
-222 -149 -363 -199 -65 -23 -290 -126 -330 -151 -49 -31 -418 -196 -424 -190
-5 6 343 177 407 201 25 9 191 90 370 180 179 90 328 165 333 165 4 1 7 -2 7
-6z m-683 -171 c-48 -50 -130 -92 -233 -117 -112 -28 -127 -30 -122 -14 5 16
326 157 357 158 l25 1 -27 -28z m-647 -263 c0 -6 -13 -27 -30 -45 -16 -19 -33
-47 -36 -62 -4 -15 -18 -48 -32 -74 -21 -40 -36 -53 -103 -88 -48 -25 -83 -50
-91 -66 -10 -19 -59 -47 -208 -115 -107 -50 -222 -102 -255 -116 -160 -67
-472 -209 -568 -259 -161 -83 -372 -174 -457 -196 -41 -11 -149 -39 -240 -63
-91 -25 -175 -42 -186 -39 -13 3 -42 -5 -72 -20 -28 -14 -107 -42 -177 -61
-70 -20 -144 -42 -164 -50 -62 -25 -683 -196 -695 -192 -16 6 59 41 693 317
316 138 593 261 615 272 52 27 1988 867 1999 868 4 0 7 -5 7 -11z m-4186
-1758 c3 -5 -1 -14 -8 -20 -16 -13 -32 2 -21 19 8 12 22 13 29 1z"
          />
          <path
            d="M6460 2521 c-58 -21 -143 -57 -190 -80 -60 -30 -94 -41 -115 -38 -21
3 -43 -3 -72 -22 -46 -28 -52 -41 -28 -61 11 -9 21 -9 45 4 16 9 42 22 58 30
15 8 114 56 221 106 107 49 197 92 199 95 11 11 -17 2 -118 -34z"
          />
          <path
            d="M6925 8947 c-110 -55 -652 -319 -1205 -587 -1296 -628 -1551 -753
-1547 -757 2 -2 55 21 118 51 63 29 656 310 1319 624 663 313 1270 600 1350
637 80 37 153 76 163 87 17 20 23 49 10 46 -5 0 -98 -46 -208 -101z"
          />
          <path
            d="M6360 7864 c-1738 -843 -2075 -1007 -2085 -1016 -16 -15 132 55 1810
849 627 297 1154 545 1171 552 30 12 61 56 46 64 -4 2 -428 -200 -942 -449z"
          />
          <path d="M4095 7570 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
          <path
            d="M7055 7339 c-258 -125 -738 -357 -1065 -515 -896 -432 -1521 -737
-1517 -741 2 -2 204 91 448 206 610 287 2581 1220 2598 1229 19 11 34 52 18
51 -7 0 -223 -104 -482 -230z"
          />
          <path d="M4235 6830 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
          <path
            d="M6870 6334 c-1676 -813 -1990 -967 -1987 -970 4 -4 381 173 1891 889
841 399 1061 507 1067 525 6 15 5 22 -4 21 -7 -1 -442 -210 -967 -465z"
          />
          <path
            d="M7755 5901 c-176 -86 -696 -338 -1155 -560 -1101 -533 -1491 -724
-1487 -728 4 -3 661 307 2131 1004 765 362 871 418 839 436 -4 2 -152 -66
-328 -152z"
          />
          <path
            d="M8200 5469 c-91 -45 -507 -247 -925 -449 -1093 -527 -1925 -933
-1921 -937 7 -7 3008 1415 3018 1431 10 15 10 36 0 36 -4 0 -82 -37 -172 -81z"
          />
          <path
            d="M8570 4787 c-25 -13 -522 -254 -1105 -536 -1620 -784 -1886 -914
-1882 -918 10 -9 3018 1421 3029 1441 17 31 4 35 -42 13z"
          />
          <path
            d="M5064 4594 c-18 -14 -18 -14 6 -3 31 14 36 19 24 19 -6 0 -19 -7 -30
-16z"
          />
          <path
            d="M7225 2623 c-180 -52 -245 -75 -240 -83 4 -6 37 -10 74 -10 74 0 137
25 201 79 39 34 36 35 -35 14z"
          />
          <path
            d="M5586 1485 c-120 -54 -126 -59 -125 -99 2 -29 2 -29 6 -4 4 23 20 35
106 78 90 46 131 70 117 70 -3 0 -49 -20 -104 -45z"
          />
          <path
            d="M5014 1201 c-82 -32 -240 -115 -393 -206 -116 -69 -321 -215 -302
-215 29 0 167 74 291 157 74 49 209 129 300 177 91 49 174 95 185 102 32 23
-2 16 -81 -15z"
          />
          <path
            d="M4096 1131 c-38 -14 -71 -32 -74 -40 -7 -21 36 -7 111 34 73 41 59
43 -37 6z"
          />
        </g>
      </>
    </BasicSvg>
  );
};

FallbackIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};
